import { cn, emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { asMaybeasy, Maybe } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import { distanceOfTimeInWords } from '../../../Time';
import { T } from '../../../Translations';
import * as style from './Style/style.module.css';
import { formatDate } from './utiles';

interface Props {
  dateTime: Maybe<Date>;
  position: string;
}

function DateTime({ dateTime, position }: Props) {
  return asMaybeasy(dateTime)
    .map((dateTime) => <_DateTime dateTimeValue={dateTime} position={position} />)
    .getOrElse(emptyFragment);
}

const _DateTime = observer(
  ({ dateTimeValue, position }: { dateTimeValue: Date; position: Props['position'] }) => {
    return (
      <Typography
        as="div"
        variant="bodyMedium"
        className={cn('w-1/2', position)}
        title={formatDate(dateTimeValue)}
        color="dark"
      >
        <div className={style.trigger_hover}>
          <T {...distanceOfTimeInWords(new Date(), dateTimeValue)} />
        </div>
      </Typography>
    );
  },
);

export default observer(DateTime);
